'use client';

import { Suspense } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Header from '@/components/Header';
import { isCloneProfilePath, shouldShowCloneDashboardChrome } from '@/lib/clone-profile-path';
import { useAuthStore } from '@/lib/store';

function ClientLayoutWrapperContent() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { isAuthenticated, isLoading } = useAuthStore();
  const isClonePage = isCloneProfilePath(pathname);
  const isTalentEmbedVideomode = isClonePage && searchParams.get('videomode') === 'true';

  const isDashboard = pathname?.startsWith('/dashboard');
  const isJobsPage = pathname === '/jobs';
  const isCareerRoadmapPage = pathname === '/career-roadmap';
  const isCoursesPage = pathname === '/courses';
  const isCapabilitiesPage = pathname === '/capabilities';
  const isReferPage = pathname === '/refer';
  const isCloneSettingsPage = pathname?.startsWith('/clone-settings');
  const isCloneActivityPage = pathname === '/clone-activity';

  if (
    isDashboard ||
    isJobsPage ||
    isCareerRoadmapPage ||
    isCoursesPage ||
    isCapabilitiesPage ||
    isReferPage ||
    isCloneSettingsPage ||
    isCloneActivityPage
  ) {
    return null;
  }

  if (isTalentEmbedVideomode) {
    return null;
  }

  // Clone page picks public vs dashboard chrome only after auth resolves, to avoid a header flash.
  if (
    (isClonePage && isLoading) ||
    shouldShowCloneDashboardChrome(pathname, isAuthenticated, isTalentEmbedVideomode)
  ) {
    return null;
  }

  return <Header />;
}

export default function ClientLayoutWrapper() {
  return (
    <Suspense fallback={null}>
      <ClientLayoutWrapperContent />
    </Suspense>
  );
}
